import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';

import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { Pane, Dialog, Button, Label, Textarea, SelectField } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import LocalPrintshopIcon from '@material-ui/icons//LocalPrintshop';
import { Form } from 'react-bootstrap';


// import { Form } from 'react-bootstrap';

// import Lottie from 'lottie-react-web';
// import animation from '../../assets/json/clean.json';
import 'react-toastify/dist/ReactToastify.css';
import { createMuiTheme } from '@material-ui/core/styles';

import * as moment from "moment-timezone";
import Login from '../common/login';
import exportFromJSON from 'export-from-json'
import DataTable from 'react-data-table-component';

const customStyles = {

    rows: {
        style: {
            minHeight: '72px', // override the row height
            border: 'solid 1px black'

        },
    },

    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            justifyContent: 'center',
            ' font-size': '25px',
            'font-weight': 'bold',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            border: 'solid 1px black',
            ' font-size': '20px',
            'font-weight': 'bold',
            justifyContent: 'center',
        },
    },
};
const conditionalRowStyles = [
    {
        when: row => row.replacement,
        style: {
            backgroundColor: "#343a40",
            userSelect: "none",
            color: 'white'
        }
    },
    {
        when: row => row.check,
        style: {
            backgroundColor: "#ffc107",
            userSelect: "none",
            color: 'white'
        }
    },
    {
        when: row => row.seleced,
        style: {
            backgroundColor: "#28a745",
            userSelect: "none",
            color: 'white'
        }
    },
    {
        when: row => row.out,
        style: {
            backgroundColor: "#0c71c1",
            userSelect: "none",
            color: 'white'
        }
    },
];

const columns = [
    {
        name: 'المتبقي',
        selector: row => row.items_av,
        sortable: true,

        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}><p id={row.id} /></div>


    },
    {
        name: 'المادة',
        selector: row => row.notes2,
        sortable: true,

        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}>{row.notes2}</div>


    },
    {
        name: 'ملاحظات',
        selector: row => row.notes,
        sortable: true,
        width: "225px",
        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}>{row.notes}</div>

    },

    {
        name: 'السعر',
        selector: row => row.price,
        sortable: true,
        width: "120px",
    },
    {
        name: 'البيج / المستخدم',
        selector: row => row.government + " / " + row.city,
        sortable: true,
        width: "305px",
        textAlign: "center",
        cell: row => <div style={{ fontSize: 15, textAlign: "center" }}>{row.page_name + " / " + row.user.user_name}</div>

    },
    {
        name: 'العنوان',
        selector: row => row.government,
        sortable: true,
        width: "200px",
        textAlign: "center",
        cell: row => <div style={{ fontSize: 15, textAlign: "center" }}>{row.government}</div>

    },
    {
        name: 'رقم الهاتف',
        selector: row => row.phone,
        width: "200px",

    },
    {
        name: 'التاريخ',
        selector: row => row.add_at,
        sortable: true,
        width: "225px",
        cell: row => <div style={{ textAlign: "center", fontSize: 15 }}>{moment(row.add_at).tz('Asia/baghdad').format('YYYY/MM/DD LT')}</div>

    },
    {
        name: ' الوصل',
        selector: row => row.id,
        sortable: true,
        width: "150px",
    },
];
let counts = []
const cookies = new Cookies();
let id = 0
class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            total: '',
            total_items: 0,
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,
            ordes2: [],
            shiper: [],
            id: '',
            ids: [],
            company: 'none',
            selectedData: [],
            price: 0
        }

        this.Orders()

    }
    rowSelect(data) {

        var Data = data.data;
        var row = data.rowsSelected;

        let ids = []
        for (let index = 0; index < row.length; index++) {
            let id = Data[index].data.id

            ids.push(id)
        }
        this.setState({ ids })
        // for (let index = 0; index < row.length; index++) {
        //     const element = array[index];

        // } 
        // this.setState({
        //     TableIndex: row,
        //     TableData: Data,
        //     button: true,
        // })
    }
    handleRowClicked(row) {

        let data = this.state.orders
        for (let index = 0; index < data.length; index++) {

            if (data[index].id === row.id) {
                data[index].seleced = !data[index].seleced
            }

        }

        this.setState({ orders: data })
    }




    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                // root: {
                //     //   backgroundColor: "#FF0000",
                //     textAlign: 'center',
                //     fontSize: '25px',
                //     fontWeight: 'bold',
                //     border: '2px solid'

                // },

            },

            MuiTableCell: {
                root: {
                    textAlign: 'right',

                },
                // head: {
                //     // backgroundColor: "#FF0000",
                //     textAlign: 'center',
                //     fontWeight: 'bold',
                //     fontSize: '25px',
                //     border: '2px solid'
                // }
            },

        }
    })

    Orders() {

        var header = { "Content-Type": "application/json", token: cookies.get("token") };

        axios.get(host + `dashbord/shiper/all/`, { headers: header })
            .then(res => {

                this.setState({ shiper: res.data.shiper })

            })
            .catch(error => {
                console.log(error.response)
            });
        axios.get(host + `users/orders/prints/unavailable`, { headers: header })
            .then(res => {
                let arr = [];
                let items = res.data.data.orders
                console.log(res.data.data.orders[0]);
                counts = res.data.data.counts
                let ordes2 = []
                for (let i = 0; i < items.length; i++) {

                    items[i].address = items[i].government + "/" + items[i].city;
                    items[i].seleced = false;
                    items[i].out = false;
                    arr.push(items[i]);

                }


                this.setState({
                    orders_count: items.length,
                    orders: items,
                    spin: false,
                    total_items: res.data.data.items_sum,
                    total_orders: res.data.data.order_count,
                    items_cost: res.data.data.items_cost,
                    orders_cost: res.data.data.sells,
                    ordes2
                });
            })
            .catch(error => {
                console.log(error.response)
            });
    }
    handleChangeFrom = date => {


        this.setState({
            from: date
        });
    };
    handleChangeTo = date => {
        this.setState({
            to: date
        });
    };
    download() {
        const data = this.state.ordes2
        const fileName = `${moment(new Date()).format('YYYY-MM-DD')}/${id}`
        const exportType = exportFromJSON.types.xls

        exportFromJSON({ data, fileName, exportType })
    }
    handleRowClicked = row => {
        let out = false

        let selectditems = this.state.selectedData;
        let t_price = 0
        let check = this.state.selectedData.find((item) => item.id === row.id)
        if (check) {
            t_price = 0
            selectditems = this.state.selectedData.filter((item) => item.id !== row.id)

            row.ordersFormItems.map((item) => {

                let objIndex = counts.findIndex(obj => obj.id == item.components.id);
                counts[objIndex].count = counts[objIndex].count + item.count
            })
            document.getElementById(row.id).innerText = ""



            out = false;
        } else {
            let div = document.getElementById(row.id)

            let items_r = ``
            row.ordersFormItems.map((item) => {

                let objIndex = counts.findIndex(obj => obj.id == item.components.id);
                counts[objIndex].count = counts[objIndex].count - item.count
                items_r = `${items_r}  ${item.components.name + " :" + counts[objIndex].count}`





                var span = document.createElement('p');
                span.className = 'content';
                var text = document.createTextNode(`${item.components.name + " :" + counts[objIndex].count}`);

                // span.style.color="#ffc107"
                span.appendChild(text);


                if (counts[objIndex].count < 0) {

                    out = true
                    span.style.color = "#ffc107"


                } else {
                    span.style.color = "#fafafa"
                }

                div.appendChild(span)
            })






            t_price = 0
            selectditems.push(row)


            // var span = document.createElement('span');
            // span.className = 'content';
            // var text = document.createTextNode("You got this!");
            // span.style.color = "#fafafa"
            // // span.style.color="#ffc107"
            // span.appendChild(text);
            // div.appendChild(span)


            console.log(row);
        }


        for (let index = 0; index < selectditems.length; index++) {
            if (selectditems[index].government === "بغداد") {
                t_price = t_price + selectditems[index].price - 4
            } else {
                t_price = t_price + selectditems[index].price - 6

            }

        }
        // toast(t_price, {
        //     position: "bottom-center",
        //     autoClose: 1500,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true
        // });

        const updatedData = this.state.orders.map(item => {
            if (row.id !== item.id) {
                return item;
            }

            return {
                ...item,
                seleced: !item.seleced,
                out: out
            };
        });



        this.setState({ orders: updatedData, selectedData: selectditems, price: t_price })
        // setData(updatedData);
    };


    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        // if (this.state.spin) {
                        return (
                            <div >




                                <br />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                                    <div style={{ textAlign: 'left', marginRight: '20px', fontSize: "25px", fontWeight: "bold", color: '#28a745' }}>
                                        تحويل الطلبات الغير موجودة بالنظام
                                    </div>
                                    <div style={{ textAlign: 'right', marginRight: '15px' }}>
                                        <Component initialState={{ isShown: false, items: [], notes: "", spin: true, check: 0, Loading: false }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        isConfirmLoading={state.Loading}
                                                        onCloseComplete={() => {
                                                            setState({ isShown: false, check: 0 })
                                                            this.setState({ company: 'none' })
                                                        }}
                                                        confirmLabel=" تحويل"

                                                        intent="success"
                                                        hasFooter={true}
                                                        title={"تحويل الطلبات"}
                                                        onConfirm={() => {
                                                            setState({ Loading: true })
                                                            var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("token") };
                                                            let formData = new FormData();
                                                            for (let i = 0; i < this.state.selectedData.length; i++) {
                                                                formData.append("orders_id", this.state.selectedData[i].id);

                                                            }


                                                            axios({ url: host + `users/ordersto/prints`, method: "POST", data: formData, headers: header })
                                                                .then(response => {

                                                                    window.alert('تم تحويل الطلبات الى الانتظار')

                                                                    window.location.reload();


                                                                })
                                                                .catch(error => { window.alert('حصل خطأ ') })
                                                        }}
                                                    >
                                                        <div style={{ direction: 'rtl', textAlign: 'center' }} >

                                                            <h4>هل متأكد من تحويل هذه الطلبات الى حالة قبل الطباعة ؟</h4>

                                                            {/* <Textarea id="notes" value={state.notes} name="textarea-1" placeholder="اسم المندوب"
                                                                onChange={(e) => {

                                                                    setState({ notes: e.target.value })
                                                                }} /> */}
                                                        </div>
                                                    </Dialog>
                                                    <Button marginLeft={30} marginTop={5} disabled={this.state.selectedData.length > 0 ? false : true} appearance="primary"
                                                        iconBefore={LocalPrintshopIcon}
                                                        onClick={() => {


                                                            setState({ isShown: true, spin: true })
                                                        }}
                                                        height={45}
                                                    >
                                                        تحويل {this.state.selectedData.length} وصل
                                                    </Button>
                                                </Pane>
                                            )}
                                        </Component>





                                        <br></br>
                                        <br></br>
                                        <br></br>
                                    </div>
                                </div>


                                <div>
                                    <div className='DataTableContiner'>
                                        <DataTable title="تحويل الطلبات" highlightOnHover
                                            pointerOnHover direction={'center'}
                                            conditionalRowStyles={conditionalRowStyles}
                                            customStyles={customStyles}
                                            columns={columns}
                                            data={this.state.orders}
                                            //   selectableRows
                                            onRowClicked={this.handleRowClicked}

                                            onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
                                                //   console.log(selectedRows);
                                                this.setState({ selectedData: selectedRows })


                                            }}
                                        //    selectableRowsComponent={Checkbox2}
                                        // onRowClicked={(row) => {

                                        //     this.handleRowClicked(row)
                                        // }}

                                        />

                                    </div>

                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                        // }
                        // else {
                        //     return (
                        //         <div style={{ width: '100%', height: 'calc(100vh - 60px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        //             <Lottie
                        //                 options={{
                        //                     animationData: animation
                        //                 }}
                        //             />
                        //         </div>
                        //     )
                        // }
                    }
                    }
                </Context.Consumer>
            )
        }
        else {
            return (
                <Login />
            )
        }
    }
}


export default Selles_Reports;